import request from '@/utils/request'
import API from './api'

export const QINIU_DOMAIN='https://tikuqiniu.knowbox.cn/'
export const QINIU_UPLOAD_PATH='//up.qbox.me/'

//获取七牛上传token
export function getQiniuTokenAPI() {
  return request({
    url: API.UPLOAD_TOKEN,
    method: 'post'
  })
}

// 获取标签种类
export function getTagClassesAPI() {
	return request({
		url: API.QSELECTTNEW_TASK_TAG_TYPE,
		method: 'post'
	})
}

// 获取所有的类型 
export function getAllTaskTypeAPI() {
	return request({
		url: API.QSELECTTNEW_TASK_FILTER,
		method: 'post'
	})
}

//语文汉语转拼音
export function getPinyinAPI(data) {
  return request({
    url: API.GET_CHINESE_PINYIN,
    method: 'post',
    data
  })
}


//题盒子任务详情
export function getTaskInfoAPI(data) {
  return request({
    url: API.GET_TASK_INFO,
     method: 'post',
    data
  })
}

// 获取用户信息
export function getUserInfoAPI(data) {
  return request({
    url: API.GET_USER_INFO,
    method: 'post',
    data
  })
}


//退出登录
export function loginOutAPI() {
  return request({
    url: API.EXIT_LOGIN,
    method: 'post'
  })
}

// 获取题目
export function getQuestionDetailAPI(data) {
  return request({
    url: API.GET_QUESTION,
    method: 'post',
    data
  })
}

// 退出登陆
export function exitLoginAPI(data) {
  return request({
    url: API.EXIT_LOGIN,
    method: 'post',
    data
  })
}

/*修改学科学段*/
export function modifySubjectAPI(data) {
  return request({
    url: API.UPDATE_SUBJECT,
    method: 'post',
    data
  })
}

// 会认生字，会写生字
export function setCateitemListAPI(data) {
  return request({
    url: API.CATEITEM_LIST,
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/API/common.js